var _defs, _circle, _path, _path2, _path3, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowerHeadHandShower({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: none;\n      }\n\n      .st0, .st1, .st2 {\n        stroke-linecap: round;\n      }\n\n      .st0, .st2 {\n        stroke: #5e6368;\n        stroke-linejoin: round;\n      }\n\n      .st1 {\n        stroke: #74aa4e;\n        stroke-dasharray: 1.14 1.89;\n        stroke-miterlimit: 10;\n      }\n\n      .st2 {\n        fill: #fff;\n      }\n\n      .st3 {\n        fill: #5e6368;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 49.1,
    cy: 52,
    r: 4.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.1,54.1c-1.4,0-3.6.8-5.3,1.3-.3.1-.4-.2-.2-.4,4.3-3.9,4.3-4.3,5.3-9.1.1-.3.4-.3.5,0,1.1,4.8,1.1,5.3,5.3,9.1.2.2,0,.5-.2.4-1.8-.5-4-1.3-5.4-1.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.9,19.4c0-.5-.1-.5-.6-.7-2.8-1.1-2.6-3.6-4.3-3.6s-1.5,2.5-4.3,3.6c-.4.2-.6.2-.6.7,0,0,9.8,0,9.8,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.5,22.5v14.5M50.2,22.5v16.5M47.9,21.2v16.1M52.5,21.2v16.1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 67.9,
    cy: 49.5,
    r: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 67.9,
    cy: 47.4,
    r: 0.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 67.9,
    cy: 45.3,
    r: 0.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 47.9,
    cy: 19.7,
    r: 0.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 50.2,
    cy: 19.7,
    r: 0.6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 52.5,
    cy: 19.7,
    r: 0.6
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 45.5,
    cy: 19.7,
    r: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.39,57.34v-13.4h2.1v13.4h-2.1ZM65,49.5v-3.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.4,57.5c0,3.7,3.9,13.5-2.1,13.5-7.1,0-1.6-17.1-1.6-36.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.6,77.1h-5.5c-3.8,0-8,1.7-11.4,4.7l-4.2,3.7M55.4,77.1h5.5c3.8,0,8,1.7,11.4,4.7l4.2,3.7M23.5,10.5h51.1M48.9,15.1v-2.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowerHeadHandShower);
export default __webpack_public_path__ + "static/media/shower-head-hand-shower.fa44b360fb2518cc0adcc178a271beea.svg";
export { ForwardRef as ReactComponent };